import './FilterTags.css';
import React, {useRef, useEffect} from 'react';

function FilterTags(props) {
  const {filterList, delLink, messages, setSelectedFiltersHeight} = props;
  const {CT_BCSF_FILTER_FROM, CT_BCSF_FILTER_TO} = messages;
  const selectedFiltersRef = useRef(null);

  useEffect(() => {
    if (props.isMobile) {
      if (selectedFiltersRef.current) {
        setSelectedFiltersHeight(selectedFiltersRef.current.offsetHeight)
      } else {
        setSelectedFiltersHeight(0)
      }
    }
  }, [filterList])



  function onClick(asyncUrl) {
    console.log(selectedFiltersRef.current.offsetHeight)
    if (props.isMobile) setSelectedFiltersHeight(0)
    props.onPropChange(typeof asyncUrl === 'string' ? asyncUrl : '');
  }

  return (
      <div className="selected-filters" ref={selectedFiltersRef}>
        <ul className="selected-filters-list" data-container="selected-filters">
          {
            Object.keys(filterList).map((key) => {
              const filter = filterList[key];
              if (key === 'PRICE') {
                return (
                    <li key={key}
                        onClick={(event) => {
                          onClick(filter.ASYNC_URL);
                        }}>
                      <label>{`${CT_BCSF_FILTER_FROM} ${filter.FROM} ₴ ${CT_BCSF_FILTER_TO} ${filter.TO} ₴`}</label>
                    </li>
                );
              } else {
                return (
                    <li key={filter.ID}
                        onClick={(event) => {
                          onClick(filter.ASYNC_URL);
                        }}>
                      <label>{filter.NAME}</label>
                    </li>
                );
              }
            })
          }
          <li onClick={(event) => {
            onClick('');
          }}>
            <span className="reset-filters btn-link">
              {messages.CT_BCSF_CLEAR_FILTER}
            </span>
          </li>
        </ul>
      </div>
  );
}

export default FilterTags;